import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UnsavedChangesService {
  private checkCallbacks: Map<string, () => boolean | Promise<boolean>> = new Map();

  register(key: string, callback: () => boolean | Promise<boolean>): void {
    this.checkCallbacks.set(key, callback);
  }

  unregister(key: string): void {
    this.checkCallbacks.delete(key);
  }

  async hasUnsavedChanges(): Promise<boolean> {
    for (const callback of this.checkCallbacks.values()) {
      if (await callback()) {
        return true;
      }
    }
    return false;
  }
}
